import { createRouter, createWebHistory } from "vue-router";
import { roles } from "@/router/permissions/accessRoles";
import middleware from "@/router/middleware";

let routes = [
  {
    path: "/",
    name: "home",
    // component: HomeView,
    component: () => import("@/views/HomeView.vue"),
    beforeEnter: middleware.auth,
  },
  {
    path: "/nao-autorizado",
    name: "nao-autorizado",
    component: () => import("@/views/autenticacao/NaoAutorizado.vue"),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: middleware.auth,
  },
  {
    path: "/:pathMatch(.*)*",
    name: "not-found",
    component: () => import("@/views/paginas/errors/PageNotFound.vue"),
    beforeEnter: middleware.auth,
  },
  {
    path: "/:pathMatch(.*)",
    name: "bad-not-found",
    component: () => import("@/views/paginas/errors/PageNotFound.vue"),
    beforeEnter: middleware.auth,
  },
  {
    path: "/paginas",
    name: "paginas.index",
    component: () => import("@/views/paginas/paginas/ListaPaginas.vue"),
    beforeEnter: middleware.auth,
  },
  {
    path: "/configuracao-menus-meio",
    name: "configuracao-menus-meio.index",
    component: () => import("@/views/paginas/configuracaoMenus/ConfiguracaoMenus.vue"),
    beforeEnter: middleware.auth,
  },
  {
    path: "/configuracao-menus-superior",
    name: "configuracao-menus.index",
    component: () => import("@/views/paginas/configuracaoMenus/ConfiguracaoMenuSuperior.vue"),
    beforeEnter: middleware.auth,
  },
  {
    path: "/configuracao-menus-subsuperior",
    name: "configuracao-menus-sub-superior.index",
    component: () => import("@/views/paginas/configuracaoMenus/ConfiguracaoMenuSubSuperior.vue"),
    beforeEnter: middleware.auth,
  },

  {
    path: "/paginas/create",
    name: "criar.pagina",
    component: () => import("@/views/paginas/paginas/AdicionaPagina.vue"),
    beforeEnter: middleware.auth,
  },
  {
    path: "/paginas/:id/edit",
    name: "editapagina",
    component: () => import("@/views/paginas/paginas/EditaPagina.vue"),
    beforeEnter: middleware.auth,
    props: true,
  },
  {
    path: "/paginas/:id/status",
    name: "pagina.status",
    component: () => import("@/views/paginas/paginas/StatusPagina.vue"),
    beforeEnter: middleware.auth,
    props: true,
  },
  {
    path: "/paginasEstaticas",
    name: "paginasEstaticas.index",
    component: () => import("@/views/paginas/paginasEstaticas/ListaPaginasEstatica.vue"),
    beforeEnter: middleware.auth,
  },
  {
    path: "/paginasEstaticas/create",
    name: "criar.paginaEstatica",
    component: () => import("@/views/paginas/paginasEstaticas/AdicionaPaginaEstatica.vue"),
    beforeEnter: middleware.auth,
  },
  {
    path: "/paginasEstaticas/:id/edit",
    name: "editapaginaestatica",
    component: () => import("@/views/paginas/paginasEstaticas/EditaPaginaEstatica.vue"),
    beforeEnter: middleware.auth,
    props: true,
  },
  {
    path: "/paginasEstaticas/:id/status",
    name: "pagina.statusEstatus",
    component: () => import("@/views/paginas/paginasEstaticas/StatusPaginaEstatica.vue"),
    beforeEnter: middleware.auth,
    props: true,
  },
  {
    path: "/menus",
    name: "menu.index",
    component: () => import("@/views/paginas/menus/ListaMenus.vue"),
    beforeEnter: middleware.auth,
  },
  {
    path: "/menus/create",
    name: "menu.create",
    component: () => import("@/views/paginas/menus/AdicionaMenu.vue"),
    beforeEnter: middleware.auth,
  },
  {
    path: "/menus/:id/edit",
    name: "menu.edit",
    component: () => import("@/views/paginas/menus/EditaMenu.vue"),
    beforeEnter: middleware.auth,
    props: true,
  },
  {
    path: "/menus/:id/status",
    name: "menus.status",
    component: () => import("@/views/paginas/menus/StatusMenu.vue"),
    beforeEnter: middleware.auth,
    props: true,
  },
  {
    path: "/glossarios",
    name: "glossarios.index",
    component: () => import("@/views/paginas/glossarios/ListaGlossarios.vue"),
    beforeEnter: middleware.auth,
  },
  {
    path: "/glossarios/create",
    name: "glossarios.create",
    component: () => import("@/views/paginas/glossarios/AdicionaGlossario.vue"),
    beforeEnter: middleware.auth,
  },
  {
    path: "/glossarios/:id/edit",
    name: "glossario.edit",
    component: () => import("@/views/paginas/glossarios/EditaGlossario.vue"),
    beforeEnter: middleware.auth,
    props: true,
  },
  {
    path: "/glossarios/:id/status",
    name: "glossario.status",
    component: () => import("@/views/paginas/glossarios/StatusGlossario.vue"),
    beforeEnter: middleware.auth,
    props: true,
  },
  {
    path: "/paginainicialvideo",
    name: "paginainicialvideo.index",
    component: () => import("@/views/paginas/paginaInicialVideo/ListaVideo.vue"),
    beforeEnter: middleware.auth,
  },
  {
    path: "/paginainicialvideo/create",
    name: "paginainicialvideo.create",
    component: () => import("@/views/paginas/paginaInicialVideo/AdicionaVideo.vue"),
    beforeEnter: middleware.auth,
  },
  {
    path: "/paginainicialvideo/:id/edit",
    name: "paginainicialvideo.edit",
    component: () => import("@/views/paginas/paginaInicialVideo/EditaVideo.vue"),
    beforeEnter: middleware.auth,
    props: true,
  },
  {
    path: "/paginainicialvideo/:id/status",
    name: "paginainicialvideo.status",
    component: () => import("@/views/paginas/paginaInicialVideo/StatusVideo.vue"),
    beforeEnter: middleware.auth,
    props: true,
  },
  {
    path: "/legislacoes",
    name: "legislacoes.index",
    component: () => import("@/views/paginas/legislacoes/ListaLegislacoes.vue"),
    // beforeEnter:middleware.auth,
  },
  {
    path: "/legislacoes/create",
    name: "legislacao.create",
    component: () =>
        import("@/views/paginas/legislacoes/AdicionaLegislacao.vue"),
    beforeEnter:middleware.auth,
  },
  {
    path: "/legislacoes/:id/edit",
    name: "legislacao.edit",
    component: () => import("@/views/paginas/legislacoes/EditaLegislacao.vue"),
    // beforeEnter:middleware.auth,
    props: true,
  },
  {
    path: "/legislacoes/:id/status",
    name: "legislacao.status",
    component: () => import("@/views/paginas/legislacoes/StatusLegislacao.vue"),
    // beforeEnter:middleware.auth,
    props: true,
  },
  {
    path: "/sobreoportal",
    name: "sobreoportal.index",
    component: () =>
        import("@/views/paginas/sobreoportal/ListaSobreOPortal.vue"),
    beforeEnter: middleware.auth,
  },
  {
    path: "/sobreoportal/create",
    name: "sobreoportal.create",
    component: () =>
        import("@/views/paginas/sobreoportal/AdicionaSobreOPortal.vue"),
    beforeEnter: middleware.auth,
  },
  {
    path: "/sobreoportal/:id/edit",
    name: "sobreoportal.edit",
    component: () =>
        import("@/views/paginas/sobreoportal/EditaSobreOPortal.vue"),
    beforeEnter: middleware.auth,
    props: true,
  },
  {
    path: "/sobreoportal/:id/status",
    name: "sobreoportal.status",
    component: () =>
        import("@/views/paginas/sobreoportal/StatusSobreOPortal.vue"),
    beforeEnter: middleware.auth,
    props: true,
  },
  {
    path: "/acessibilidade",
    name: "acessibilidade.index",
    component: () =>
        import("@/views/paginas/acessibilidade/ListaAcessibilidade.vue"),
    beforeEnter: middleware.auth,
  },
  {
    path: "/acessibilidade/create",
    name: "acessibilidade.create",
    component: () =>
        import("@/views/paginas/acessibilidade/AdicionaAcessibilidade.vue"),
    beforeEnter: middleware.auth,
  },
  {
    path: "/acessibilidade/:id/edit",
    name: "acessibilidade.edit",
    component: () =>
        import("@/views/paginas/acessibilidade/EditaAcessibilidade2.vue"),
    beforeEnter: middleware.auth,
    props: true,
  },
  {
    path: "/acessibilidade/:id/status",
    name: "acessibilidade.status",
    component: () =>
        import("@/views/paginas/acessibilidade/StatusAcessibilidade.vue"),
    beforeEnter: middleware.auth,
    props: true,
  },
  {
    path: "/competencia",
    name: "competencia.index",
    component: () =>
        import("@/views/paginas/competencias/ListaCompetencias.vue"),
    beforeEnter: middleware.auth,
  },
  {
    path: "/competencia/create",
    name: "competencia.create",
    component: () =>
        import("@/views/paginas/competencias/AdicionaCompetencias.vue"),
    beforeEnter: middleware.auth,
  },
  {
    path: "/competencia/:id/edit",
    name: "competencia.edit",
    component: () =>
        import("@/views/paginas/competencias/EditaCompetencias.vue"),
    beforeEnter: middleware.auth,
    props: true,
  },
  {
    path: "/competencia/:id/status",
    name: "competencia.status",
    component: () =>
        import("@/views/paginas/competencias/StatusCompetencias.vue"),
    beforeEnter: middleware.auth,
    props: true,
  },
  {
    path: "/horarioatendimento",
    name: "horarioatendimento.index",
    component: () =>
        import(
            "@/views/paginas/horariosatendimento/ListaHorariosAtendimento.vue"
            ),
    beforeEnter: middleware.auth,
  },
  {
    path: "/horarioatendimento/create",
    name: "horarioatendimento.create",
    component: () =>
        import(
            "@/views/paginas/horariosatendimento/AdicionaHorariosAtendimento.vue"
            ),
    beforeEnter: middleware.auth,
  },
  {
    path: "/horarioatendimento/:id/edit",
    name: "horarioatendimento.edit",
    component: () =>
        import(
            "@/views/paginas/horariosatendimento/EditaHorariosAtendimento.vue"
            ),
    beforeEnter: middleware.auth,
    props: true,
  },
  {
    path: "/horarioatendimento/:id/status",
    name: "horarioatendimento.status",
    component: () =>
        import(
            "@/views/paginas/horariosatendimento/StatusHorariosAtendimento.vue"
            ),
    beforeEnter: middleware.auth,
    props: true,
  },
  {
    path: "/perguntasfrequentes",
    name: "perguntasfrequentes",
    component: () =>
        import(
            "@/views/paginas/perguntasFrequentes/ListaPerguntasFrequentes.vue"
            ),
    beforeEnter: middleware.auth,
  },
  {
    path: "/perguntasfrequentes/create",
    name: "perguntasfrequentes.create",
    component: () =>
        import(
            "@/views/paginas/perguntasFrequentes/AdicionaPerguntaFrequente.vue"
            ),
    beforeEnter: middleware.auth,
  },
  {
    path: "/perguntasfrequentes/:id/edit",
    name: "perguntasfrequentes.edit",
    component: () =>
        import("@/views/paginas/perguntasFrequentes/EditaPerguntaFrequente.vue"),
    beforeEnter: middleware.auth,
    props: true,
  },
    {
        path: "/perguntasfrequentes/:id/visualizar",
        name: "perguntasfrequentes.view",
        component: () =>
            import("@/views/paginas/perguntasFrequentes/VisualizarPerguntaFrequente.vue"),
        beforeEnter: middleware.auth,
        props: true,
    },
  {
    path: "/perguntasfrequentes/:id/status",
    name: "perguntasfrequentes.status",
    component: () =>
        import("@/views/paginas/perguntasFrequentes/StatusPerguntaFrequente.vue"),
    beforeEnter: middleware.auth,
    props: true,
  },
  {
    path: "/estrutura_organizacional",
    name: "estrutura_organizacional.index",
    component: () =>
        import(
            "@/views/paginas/estruturaOrganizacional/ListaEstruturaOrganizacional.vue"
            ),
    beforeEnter: middleware.auth,
  },
  {
    path: "/estrutura_organizacional/create",
    name: "estrutura_organizacional.create",
    component: () =>
        import(
            "@/views/paginas/estruturaOrganizacional/AdicionaEstruturaOrganizacional.vue"
            ),
    beforeEnter: middleware.auth,
  },
  {
    path: "/estrutura_organizacional/:id/edit",
    name: "estrutura_organizacional.edit",
    component: () =>
        import(
            "@/views/paginas/estruturaOrganizacional/EditaEstruturaOrganizacional.vue"
            ),
    beforeEnter: middleware.auth,
    props: true,
  },
  {
    path: "/estrutura_organizacional/:id/status",
    name: "estrutura_organizacional.status",
    component: () =>
        import(
            "@/views/paginas/estruturaOrganizacional/StatusEstruturaOrganizacional.vue"
            ),
    beforeEnter: middleware.auth,
    props: true,
  },
  {
    path: "/usuarios",
    name: "usuarios.index",
    component: () => import("@/views/paginas/usuarios/ListaUsuario.vue"),
    beforeEnter: middleware.auth,
    props: true,
  },
  {
    path: "/usuarios/create",
    name: "usuarios.create",
    component: () => import("@/views/paginas/usuarios/AdicionaUsuario.vue"),
    beforeEnter: middleware.auth,
  },
  {
    path: "/usuario/:id/edit",
    name: "usuarios.edit",
    component: () => import("@/views/paginas/usuarios/EditaUsuario.vue"),
    beforeEnter: middleware.auth,
    props: true,
  },
  {
    path: "/usuario/:id/status",
    name: "usuarios.status",
    component: () => import("@/views/paginas/usuarios/StatusUsuario.vue"),
    beforeEnter: middleware.auth,
    props: true,
  },
  {
    path: "/orgaos",
    name: "orgaos.index",
    component: () => import("@/views/paginas/orgaos/ListaOrgao.vue"),
    beforeEnter: middleware.auth,
    props: true,
  },
  {
    path: "/orgaos/create",
    name: "orgaos.create",
    component: () => import("@/views/paginas/orgaos/AdicionaOrgao.vue"),
    beforeEnter: middleware.auth,
    props: true,
  },
  {
    path: "/orgaos/:id/edit",
    name: "orgaos.edit",
    component: () => import("@/views/paginas/orgaos/EditaOrgao.vue"),
    beforeEnter: middleware.auth,
    props: true,
  },
  {
    path: "/orgaos/:id/status",
    name: "orgaos.status",
    component: () => import("@/views/paginas/orgaos/StatusOrgao.vue"),
    beforeEnter: middleware.auth,
    props: true,
  },
  {
    path: "/cargos",
    name: "cargos.index",
    component: () => import("@/views/paginas/cargos/ListaCargo.vue"),
    beforeEnter: middleware.auth,
    props: true,
  },
  {
    path: "/cargos/create",
    name: "cargos.create",
    component: () => import("@/views/paginas/cargo/AdicionaCargo.vue"),
    beforeEnter: middleware.auth,
    props: true,
  },
  {
    path: "/cargos/:id/edit",
    name: "cargos.edit",
    component: () => import("@/views/paginas/cargo/EditaCargo.vue"),
    beforeEnter: middleware.auth,
    props: true,
  },
  {
    path: "/cargos/:id/status",
    name: "cargos.status",
    component: () => import("@/views/paginas/cargos/StatusCargo.vue"),
    beforeEnter: middleware.auth,
    props: true,
  },
  {
    path: "/pessoas",
    name: "pessoas.index",
    component: () => import("@/views/paginas/pessoas/ListaPessoa.vue"),
    beforeEnter: middleware.auth,
    props: true,
  },
  {
    path: "/pessoas/create",
    name: "pessoas.create",
    component: () => import("@/views/paginas/pessoa/AdicionaPessoa.vue"),
    beforeEnter: middleware.auth,
    props: true,
  },
  {
    path: "/pessoas/:id/edit",
    name: "pessoas.edit",
    component: () => import("@/views/paginas/pessoa/EditaPessoa.vue"),
    beforeEnter: middleware.auth,
    props: true,
  },
  {
    path: "/pessoas/:id/status",
    name: "pessoas.status",
    component: () => import("@/views/paginas/pessoas/StatusPessoas.vue"),
    beforeEnter: middleware.auth,
    props: true,
  },
  {
    path: "/curriculos",
    name: "curriculos.index",
    component: () => import("@/views/paginas/curriculos/ListaCurriculos.vue"),
    // beforeEnter:middleware.auth,
  },
  {
    path: "/curriculos/create",
    name: "curriculo.create",
    component: () => import("@/views/paginas/curriculos/AdicionaCurriculo.vue"),
    beforeEnter: middleware.auth,
  },
  {
    path: "/curriculos/:id/edit",
    name: "curriculo.edit",
    component: () => import("@/views/paginas/curriculos/EditaCurriculo.vue"),
    beforeEnter: middleware.auth,
    props: true,
  },
  {
    path: "/curriculos/:id/status",
    name: "curriculo.status",
    component: () => import("@/views/paginas/curriculos/StatusCurriculo.vue"),
    beforeEnter: middleware.auth,
    props: true,
  },
  {
    path: "/login",
    name: "login",
    component: () => import("@/views/autenticacao/Login.vue"),
    // meta: {
    //   requiresAuth: false,
    // },
  },
  {
    path: "/recuperar-senha",
    name: "recuperar",
    component: () => import("@/views/autenticacao/RecuperarSenha.vue"),
  },
  {
    path: "/novasenha/:token_usuario/:email",
    name: "novasenha",
    component: () => import("@/views/autenticacao/NovaSenha.vue"),
    props: true,
  },
  {
    path: "/alterarsenha",
    name: "alterarsenha",
    component: () => import("@/views/autenticacao/AlterarSenha.vue"),
  },
  {
    path: "/gestao-documentos-auditoria",
    name: "gestao-documentos-auditoria",
    component: () => import("@/views/paginas/gestaoDocumentosAuditoria/ListaGestaoDocumentosAuditoria.vue"),
    beforeEnter: middleware.auth,
    meta: { roles: roles.adminOnly },
  },
  {
    path: "/gestao-documentos-auditoria/create",
    name: "gestao-documentos-auditoria.create",
    component: () => import("@/views/paginas/gestaoDocumentosAuditoria/AdicionaGestaoDocumentosAuditoria.vue"),
    beforeEnter: middleware.auth,
    meta: { roles: roles.adminOnly },
  },
  {
    path: "/gestao-documentos-auditoria/:id/edit",
    name: "gestao-documentos-auditoria.edit",
    component: () => import("@/views/paginas/gestaoDocumentosAuditoria/EditaGestaoDocumentosAuditoria.vue"),
    beforeEnter: middleware.auth,
    meta: { roles: roles.adminOnly },
    props: true,
  },
  {
    path: "/assuntos/",
    name: "assuntos",
    component: () => import("@/views/paginas/assuntos/ListaAssuntos.vue"),
    beforeEnter: middleware.auth,
  },
  {
    path: "/assuntos/create",
    name: "assuntos.create",
    component: () => import("@/views/paginas/assuntos/AdicionaAssunto.vue"),
    beforeEnter: middleware.auth,
  },
  {
    path: "/assuntos/:id/edit",
    name: "assuntos.edit",
    component: () => import("@/views/paginas/assuntos/EditaAssunto.vue"),
    beforeEnter: middleware.auth,
    props: true,
  },
  {
    path: "/assuntos/:id/view",
    name: "assuntos.view",
    component: () => import("@/views/paginas/assuntos/VisualizaAssunto.vue"),
    beforeEnter: middleware.auth,
    props: true,
  },
  {
    path: "/assuntos/:id/status",
    name: "assuntos.status",
    component: () => import("@/views/paginas/assuntos/StatusAssunto.vue"),
    beforeEnter: middleware.auth,
    props: true,
  },
  {
    path: "/banners/",
    name: "banners.index",
    component: () => import("@/views/paginas/banners/ListaBanner.vue"),
    beforeEnter: middleware.auth,
  },
  {
    path: "/banners/create",
    name: "banners.create",
    component: () => import("@/views/paginas/banners/AdicionaBanner.vue"),
    beforeEnter: middleware.auth,
  },
  {
    path: "/banners/:id/edit",
    name: "banners.edit",
    component: () => import("@/views/paginas/banners/EditaBanner.vue"),
    beforeEnter: middleware.auth,
    props: true,
  },
  {
    path: "/banners/:id/status",
    name: "banners.status",
    component: () => import("@/views/paginas/banners/StatusBanner.vue"),
    beforeEnter: middleware.auth,
    props: true,
  },
  {
    path: "/projetos_sociais",
    name: "projetossociais.index",
    component: () =>
        import("@/views/paginas/projetosSociais/ListaProjetosSociais.vue"),
    beforeEnter: middleware.auth,
  },
  {
    path: "/projetos_sociais/create",
    name: "projetos_sociais.create",
    component: () =>
        import("@/views/paginas/projetosSociais/AdicionarProjetoSocial.vue"),
    beforeEnter: middleware.auth,
  },
  {
    path: "/projetos_sociais/:id/edit",
    name: "projetos_sociais.edit",
    component: () =>
        import("@/views/paginas/projetosSociais/EditarProjetoSocial.vue"),
    beforeEnter: middleware.auth,
    props: true,
  },
  {
    path: "/projetos_sociais/:id/status",
    name: "projetos_sociais.status",
    component: () =>
        import("@/views/paginas/projetosSociais/StatusProjetoSocial.vue"),
    beforeEnter: middleware.auth,
    props: true,
  },
  {
    path: "/certidao_estadual",
    name: "certidao_estadual.index",
    component: () =>
        import("@/views/paginas/certidaoEstadual/ListaCertidaoEstadual.vue"),
    beforeEnter: middleware.auth,
  },
  {
    path: "/certidao_estadual/create",
    name: "certidao_estadual.create",
    component: () =>
        import("@/views/paginas/certidaoEstadual/AdicionaCertidaoEstadual.vue"),
    beforeEnter: middleware.auth,
  },
  {
    path: "/certidao_estadual/:id/edit",
    name: "certidao_estadual.edit",
    component: () =>
        import("@/views/paginas/certidaoEstadual/EditaCertidaoEstadual.vue"),
    beforeEnter: middleware.auth,
    props: true,
  },
  {
    path: "/certidao_estadual/:id/status",
    name: "certidao_estadual.status",
    component: () =>
        import("@/views/paginas/certidaoEstadual/StatusCertidaoEstadual.vue"),
    beforeEnter: middleware.auth,
    props: true,
  },
  {
    path: "/formulario_informacao_cidadao",
    name: "formulario_informacao_cidadao.index",
    component: () =>
        import(
            "@/views/paginas/FormularioInformacaoCidadao/ListaFormularioInformacaoCidadao.vue"
            ),
    beforeEnter: middleware.auth,
  },
  {
    path: "/formulario_informacao_cidadao/create",
    name: "formulario_informacao_cidadao.create",
    component: () =>
        import(
            "@/views/paginas/FormularioInformacaoCidadao/AdicionaFormularioInformacaoCidadao.vue"
            ),
    beforeEnter: middleware.auth,
  },
  {
    path: "/formulario_informacao_cidadao/:id/edit",
    name: "formulario_informacao_cidadao.edit",
    component: () =>
        import(
            "@/views/paginas/FormularioInformacaoCidadao/EditaFormularioInformacaoCidadao.vue"
            ),
    beforeEnter: middleware.auth,
    props: true,
  },
  {
    path: "/formulario_informacao_cidadao/:id/status",
    name: "formulario_informacao_cidadao.status",
    component: () =>
        import(
            "@/views/paginas/FormularioInformacaoCidadao/StatusFormularioInformacaoCidadao.vue"
            ),
    beforeEnter: middleware.auth,
    props: true,
  },
  {
    path: "/links_google_drive",
    name: "links_google_drive.index",
    component: () =>
        import("@/views/paginas/linkGoogleDrive/ListaLinkGoogleDrive.vue"),
    beforeEnter: middleware.auth,
  },
  {
    path: "/links_google_drive/create",
    name: "links_google_drive.create",
    component: () =>
        import("@/views/paginas/linkGoogleDrive/AdicionaLinkGoogleDrive.vue"),
    beforeEnter: middleware.auth,
  },
  {
    path: "/links_google_drive/:id/edit",
    name: "links_google_drive.edit",
    component: () =>
        import(
            "@/views/paginas/linkGoogleDrive/EditaLinkGoogleDrive.vue"
            ),
    beforeEnter: middleware.auth,
    props: true,
  },
  {
    path: "/noticias",
    name: "noticias.index",
    component: () =>
        import("@/views/paginas/noticias/ListaNoticias.vue"),
    beforeEnter: middleware.auth,
  },
  {
    path: "/noticias/create",
    name: "noticias.create",
    component: () =>
        import("@/views/paginas/noticias/AdicionarNoticia.vue"),
    beforeEnter: middleware.auth,
  },
  {
    path: "/noticias/:id/edit",
    name: "noticias.edit",
    component: () =>
        import(
            "@/views/paginas/noticias/EditaNoticia.vue"
            ),
    beforeEnter: middleware.auth,
    props: true,
  },
  {
    path: "/cardnoticia/create",
    name: "cardnoticia.create",
    component: () =>
        import("@/views/paginas/cardNoticia/AdicionaCardNoticia.vue"),
    beforeEnter: middleware.auth,
  },
  {
    path: "/cardnoticia",
    name: "cardnoticia.index",
    component: () =>
        import("@/views/paginas/cardNoticia/ListaCardNoticia.vue"),
    beforeEnter: middleware.auth,
  },
  {
    path: "/cardnoticia/:id/edit",
    name: "cardnoticia.edit",
    component: () =>
        import(
            "@/views/paginas/cardNoticia/EditaCardNoticia.vue"
            ),
    beforeEnter: middleware.auth,
    props: true,
  },
  /*{
    path: "/saude_painel",
    name: "saudepainel",
    component: () => import("@/views/paginas/saudepainel/SaudePainel.vue"),
  },*/
  /*{
    path: "/integracoes/oauth/redirect",
    name: "integracoesredirect",
    redirect: {
      name: "integracoes",
      props: (route) => ({ code: route.query.code }),
    },
    beforeEnter: middleware.auth,
    props: true,
  },
  {
    path: "/integracoes",
    name: "integracoes",
    component: () =>
      import("@/views/paginas/integracoes/GestaoIntegracoes.vue"),
    beforeEnter: middleware.auth,
    props: true,
  },*/
  /*{
    path: "/configuracoes",
    name: "configuracoes.index",
    component: () =>
      import("@/views/paginas/configuracoes/ListaConfiguracoes.vue"),
    beforeEnter: middleware.auth,
  },
  {
    path: "/configuracoes/create",
    name: "configuracoes.create",
    component: () =>
      import("@/views/paginas/configuracoes/AdicionaConfiguracao.vue"),
    beforeEnter: middleware.auth,
  },
  {
    path: "/configuracoes/:id/edit",
    name: "configuracoes.edit",
    component: () =>
      import("@/views/paginas/configuracoes/EditaConfiguracao.vue"),
    beforeEnter: middleware.auth,
    props: true,
  },
  {
    path: "/configuracoes/:id/status",
    name: "configuracoes.status",
    component: () =>
      import("@/views/paginas/configuracoes/StatusConfiguracao.vue"),
    beforeEnter: middleware.auth,
    props: true,
  },*/
  {
    path: "/pagina_inicial_banner",
    name: "pagina_inicial_banner.index",
    component: () =>
        import("@/views/paginas/PaginaInicialBanner/ListaPaginaInicialBanner.vue"),
    beforeEnter: middleware.auth,
  },
  {
    path: "/pagina_inicial_banner/create",
    name: "pagina_inicial_banner.create",
    component: () =>
        import("@/views/paginas/PaginaInicialBanner/AdicionaPaginaInicialBanner.vue"),
    beforeEnter: middleware.auth,
  },
  {
    path: "/pagina_inicial_banner/:id/edit",
    name: "pagina_inicial_banner.edit",
    component: () =>
        import(
            "@/views/paginas/PaginaInicialBanner/EditaPaginaInicialBanner.vue"
            ),
    beforeEnter: middleware.auth,
    props: true,
  },
  {
    path: "/pagina_inicial_banner/:id/status",
    name: "pagina_inicial_banner.status",
    component: () =>
        import(
            "@/views/paginas/PaginaInicialBanner/StatusPaginaInicialBanner.vue"
            ),
    beforeEnter: middleware.auth,
    props: true,
  },
  {
    path: "/acesso-a-informacao",
    name: "acesso-a-informacao.index",
    component: () =>
        import("@/views/paginas/acessoInformacao/ListaAcessoInformacao.vue"),
    beforeEnter: middleware.auth,
  },
  {
    path: "/acesso-a-informacao/create",
    name: "acesso-a-informacao.create",
    component: () =>
        import("@/views/paginas/acessoInformacao/AdicionaAcessoInformacao.vue"),
    beforeEnter: middleware.auth,
  },
  {
    path: "/acesso-a-informacao/:id/edit",
    name: "acesso-a-informacao.edit",
    component: () =>
        import("@/views/paginas/acessoInformacao/EditaAcessoInformacao.vue"),
    beforeEnter: middleware.auth,
    props: true,
  },
  {
    path: "/cargo",
    name: "cargo.index",
    component: () => import("@/views/paginas/cargo/ListaCargo.vue"),
    beforeEnter: middleware.auth,
    props: true,
  },
  {
    path: "/cargo/create",
    name: "cargo.create",
    component: () => import("@/views/paginas/cargo/AdicionaCargo.vue"),
    beforeEnter: middleware.auth,
    props: true,
  },
  {
    path: "/cargo/:id/edit",
    name: "cargo.edit",
    component: () => import("@/views/paginas/cargo/EditaCargo.vue"),
    beforeEnter: middleware.auth,
    props: true,
  },
  {
    path: "/pessoa/create",
    name: "pessoa.create",
    redirect: { name: "pessoas.create" },
    beforeEnter: middleware.auth,
  },
  {
    path: "/pessoa",
    name: "pessoa.index",
    redirect: { name: "pessoas.index" },
    beforeEnter: middleware.auth,
  },
  {
    path: "/pessoa/:id/edit",
    name: "pessoa.edit",
    redirect: to => ({ name: "pessoas.edit", params: { id: to.params.id } }),
    beforeEnter: middleware.auth,
  },
  {
    path: "/ordenacao-cargos",
    name: "ordenacao-cargos.index",
    component: () => import("@/views/paginas/cargo/OrdenacaoCargo.vue"),
    beforeEnter: middleware.auth,
  },
  {
    path: "/ordenacao-orgaos",
    name: "ordenacao-orgaos.index",
    component: () => import("@/views/paginas/orgaos/OrdenacaoOrgao.vue"),
    beforeEnter: middleware.auth,
  },
  {
    path: "/ordenacao-banners",
    name: "ordenacao-banners.index",
    component: () => import("@/views/paginas/configuracaoBanners/ConfiguracaoBanner.vue"),
    beforeEnter: middleware.auth,
  },
  {
    path: "/ordenacao-banners-fixo",
    name: "ordenacao-banners-fixo.index",
    component: () => import("@/views/paginas/configuracaoBanners/ConfiguracaoBannerFixo.vue"),
    beforeEnter: middleware.auth,
  },
  {
    path: "/municipio/create",
    name: "municipio.create",
    component: () => import("@/views/paginas/municipio/AdicionaMunicipio.vue"),
    beforeEnter: middleware.auth,
    props: true,
  },
  {
    path: "/municipio",
    name: "municipio.index",
    component: () => import("@/views/paginas/municipio/ListaMunicipios.vue"),
    beforeEnter: middleware.auth,
    props: true,
  },
  {
    path: "/municipio/:id/edit",
    name: "municipio.edit",
    component: () => import("@/views/paginas/municipio/EditaMunicipio.vue"),
    beforeEnter: middleware.auth,
    props: true,
  },
  {
    path: "/ordenacao-noticia-tipo-imagem",
    name: "ordenacao-noticia-tipo-imagem.index",
    component: () => import("@/views/paginas/noticias/OrdenacaoTipoImagem.vue"),
    beforeEnter: middleware.auth,
  },
  {
    path: "/ordenacao-noticia-tipo-video",
    name: "ordenacao-noticia-tipo-video.index",
    component: () => import("@/views/paginas/noticias/OrdenacaoTipoVideo.vue"),
    beforeEnter: middleware.auth,
  },
  {
    path: "/ordenacao-noticia-tipo-texto",
    name: "ordenacao-noticia-tipo-texto.index",
    component: () => import("@/views/paginas/noticias/OrdenacaoTipoTexto.vue"),
    beforeEnter: middleware.auth,
  },

  // {
  //   path: "/cargos/:id/status",
  //   name: "cargos.status",
  //   component: () => import("@/views/paginas/cargos/StatusCargo.vue"),
  //   beforeEnter: middleware.auth,
  //   props: true,
  // },
  // {
  //   path: "/acesso-a-informacao/:id/status",
  //   name: "acesso-a-informacao.status",
  //   component: () =>
  //       import(
  //           "@/views/paginas/acessoInformacao/StatusAcessoInformacao.vue"
  //           ),
  //   beforeEnter: middleware.auth,
  //   props: true,
  // },
  {
    path: "/atendimentocidadao",
    name: "atendimentocidadao.index",
    component: () => import("@/views/paginas/atendimentocidadao/ListaAtendimentoCidadao.vue"),
    beforeEnter: middleware.auth,
    props: true,
  },
  {
    path: "/atendimentocidadao/create",
    name: "atendimentocidadao.create",
    component: () => import("@/views/paginas/atendimentocidadao/AdicionaAtendimentoCidadao.vue"),
    beforeEnter: middleware.auth,
    props: true,
  },
  {
    path: "/atendimentocidadao/:id/edit",
    name: "atendimentocidadao.edit",
    component: () => import("@/views/paginas/atendimentocidadao/EditaAtendimentoCidadao.vue"),
    beforeEnter: middleware.auth,
    props: true,
  },
  {
    path: "/sicpresencial/create",
    name: "sicpresencial.create",
    component: () => import("@/views/paginas/sicPresencial/AdicionaSicPresencial.vue"),
    beforeEnter: middleware.auth,
    props: true,
  },
  {
    path: "/esic/create",
    name: "esic.create",
    component: () => import("@/views/paginas/esic/AdicionaEsic.vue"),
    beforeEnter: middleware.auth,
    props: true,
  },
  {
    path: "/formulario/create",
    name: "formulario.create",
    component: () => import("@/views/paginas/formulario/AdicionaFormularioComponent.vue"),
    beforeEnter: middleware.auth,
    props: true,
  },
  {
    path: "/gerenciar-rodape/acesso-rapido",
    name: "gerenciarrodape.acessorapido.index",
    component: () => import("@/views/paginas/gerenciarRodape/acessoRapido/AcessoRapidoView.vue"),
    meta: {
      requiresAuth: true,
      roles: roles.adminOnly,
    },
    beforeEnter: middleware.auth,
  },
  {
    path: "/gerenciar-rodape/acesso-rapido/:colunaNome/update",
    name: "gerenciarrodape.acessorapido.update",
    component: () => import("@/views/paginas/gerenciarRodape/acessoRapido/UpdateAcessoRapidoView.vue"),
    meta: {
      requiresAuth: true,
      roles: roles.adminOnly,
    },
    beforeEnter: middleware.auth,
    props: true,
  },
  {
    path: "/gerenciar-rodape/rodape-portal",
    name: "gerenciarrodape.rodapeportal.index",
    component: () => import("@/views/paginas/gerenciarRodape/rodapePortal/RodapePortalView.vue"),
    meta: {
      requiresAuth: true,
      roles: roles.all,
    },
    beforeEnter: middleware.auth,
  },
  {
    path: "/gerenciar-rodape/rodape-portal/update",
    name: "gerenciarrodape.rodapeportal.update",
    component: () => import("@/views/paginas/gerenciarRodape/rodapePortal/FormularioRodapeView.vue"),
    meta: {
      requiresAuth: true,
      roles: roles.all,
    },
    beforeEnter: middleware.auth,
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    const user = JSON.parse(localStorage.getItem('user'));
    if (!user) {
      return next({ name: "nao-autorizado" });
    } else {
      next();
    }
  } else {
    return next();
  }
});

export default router;
